import { sendGet, sendPatchJson } from "./axios";

const BASE = "/dm/directory";

// Hospital directory rows, optionally narrowed by province and free text
export const getDirectoryHospitals = (params = {}) => {
  const query = new URLSearchParams();
  if (params.province_code) query.set("province_code", params.province_code);
  if (params.q) query.set("q", params.q);
  const qs = query.toString();
  return sendGet(`${BASE}/hospitals${qs ? `?${qs}` : ""}`);
};

// Partial update of one hospital; only the given fields change
export const updateDirectoryHospital = (code, payload) =>
  sendPatchJson(`${BASE}/hospitals/${code}`, payload);

export const getDirectorySummary = () => sendGet(`${BASE}/summary`);

// Asks the server to build the Excel file; the response carries its media path
export const exportDirectory = (lang) =>
  sendGet(`${BASE}/hospitals/export?lang=${lang || "vi"}`);
